import { render, staticRenderFns } from "./Wordpress.vue?vue&type=template&id=75968189"
import script from "./Wordpress.vue?vue&type=script&lang=ts"
export * from "./Wordpress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports